var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBackArrow = function SvgBackArrow(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0A3847",
    fillRule: "evenodd",
    d: "M15.714 16.327 11.374 12l4.34-4.327A.98.98 0 0 0 16 6.978a.98.98 0 0 0-.286-.693.99.99 0 0 0-1.392 0l-5.034 5.02a.98.98 0 0 0 0 1.388l5.034 5.02a.987.987 0 0 0 1.392 0A.98.98 0 0 0 16 17.02a.98.98 0 0 0-.286-.693"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBackArrow);
export default ForwardRef;